import React from "react";
import styles from "@/styles/post.module.css";
import Link from "next/link";
import { PostContentHeadProps } from "@/types/modules/post/components";
import { DottedSeparator } from "@/components/ui-kit/Decorations/DottedSeparator";
import { AuthorLink } from "@/components/modules/Author/AuthorLink";
import { PostAudioPlayer } from "@/components/modules/Post/PostAudioPlayer";
import { format } from "date-fns";
import { cs } from "date-fns/locale";

export const PostContentHead: React.FC<PostContentHeadProps> = ({ post }) => {
  return (
    <div className={styles.postContentContainer}>
      <div className="flex flex-col text-sm">
        <div>
          <div className="font-condensed text-lg text-brown dark:text-orange">
            {post.postDetails?.pageHeaderSuperTitle}
          </div>
          <h1 className="py-2 font-mercury text-7xl font-semibold text-dark dark:text-white sm:text-8xl">
            {post.title}
          </h1>
        </div>
      </div>
      {post.isAdvertorial ? (
        <>
          <DottedSeparator />
          <div>
            <div className="flex items-center justify-between py-4">
              <span className="mt-0.5 font-condensed text-lg text-dark dark:text-white">{post.advertorialText}</span>
            </div>
            <DottedSeparator />
          </div>
        </>
      ) : (
        <>
          <div className="py-[16px]">
            <AuthorLink
              authors={post.authors}
              className="flex items-center text-dark no-underline decoration-transparent decoration-1 transition-all ease-in-out hover:decoration-current dark:text-white md:underline"
            />
          </div>
          <DottedSeparator />
        </>
      )}
      <div
        className={`border-b border-dark py-2 dark:border-white ${
          post.advertorialText || post.issue ? "flex justify-between" : ""
        }`}
      >
        <p className="text-sm font-light text-dark dark:text-white">
          {post.date && format(new Date(post.date.split(" ")[0]), "d. MMMM Y", { locale: cs })}
        </p>
        {post.isAdvertorial && <span className="text-sm">Advertorial</span>}
        {post.issue && post.issue?.link && (
          <Link
            className="text-sm text-dark decoration-dark-70 decoration-1 underline-offset-4 hover:underline dark:text-white"
            href={post.issue?.link}
          >
            {post.issue.title} · Číslo {post.issue.issueNumber}
          </Link>
        )}
      </div>
      {post?.audio && <PostAudioPlayer post={post!} />}
    </div>
  );
};
